import {
	ALERT_78,
	ALERT_NO_DOCUMENTS_TO_PREVIEW_OR_DOWNLOAD,
} from '@/constant';
import { cn, insertObjectIf, showAlert } from '@/utils';
import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import { isNotNilOrEmpty } from 'ramda-adjunct';

import { TableLinkTo } from '..';
import Button from '../common/button';
import {
	TDefineDocumentPreviewButtonProps,
	TDefineDocumentPreviewProps,
} from './define-document-preview.type';
import DefineDocumentPreview from './define-document-preview.view';

const DefineDocumentPreviewButton = ({
	className,
	label = '미리보기',
	link,
	readonly,
	filesNoAcceptDownloadAndPreview,
	...props
}: TDefineDocumentPreviewButtonProps) => {
	const [open, setOpen] = useState(false);

	const defineDocumentPreviewModal =
		useRef<FunctionComponent<TDefineDocumentPreviewProps>>();

	const onOpenModal = useCallback(() => {
		if (props.isAllDocument)
			return showAlert(ALERT_NO_DOCUMENTS_TO_PREVIEW_OR_DOWNLOAD(true));

		if (!defineDocumentPreviewModal.current) {
			defineDocumentPreviewModal.current = DefineDocumentPreview;
		}
		if (isNotNilOrEmpty(filesNoAcceptDownloadAndPreview)) {
			showAlert(
				ALERT_78(filesNoAcceptDownloadAndPreview as string, true),
				() => {
					if (props.isDocumentNotReadonly) {
						showAlert(ALERT_NO_DOCUMENTS_TO_PREVIEW_OR_DOWNLOAD(true));
						return;
					}

					setOpen(true);
				}
			);
		} else {
			setOpen(true);
		}
	}, [filesNoAcceptDownloadAndPreview, props]);

	const onCancel = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<>
			{link ? (
				<TableLinkTo
					label={label}
					{...insertObjectIf(!readonly, {
						onClick: onOpenModal,
					})}
				/>
			) : (
				<Button
					secondary
					className={cn('min-w-0', className)}
					onClick={onOpenModal}
				>
					{label}
				</Button>
			)}
			{defineDocumentPreviewModal.current && (
				<defineDocumentPreviewModal.current {...{ ...props, open, onCancel }} />
			)}
		</>
	);
};

export default memo(DefineDocumentPreviewButton);
